import React, { useEffect, useRef, useState } from 'react'
import { META_GENDERS, META_SPECIAL_AD_CATEGORIES } from '../SocialMediaConstant';
import * as API from '../../../framework/API/api';
import { DropDownList, MultiSelect } from '@progress/kendo-react-dropdowns';
import GetInstedDataDropdown from '../../../components/GetInstedDataDropdown';
import MyMultiSelect from '../../../components/MyMultiSelect';
import { useTranslation } from '../../../locale/useTranslation';

const MetaAudienceForm = (props) => {
    const { dataItem = {}, onChange } = props;

    const lang = useTranslation();

    const [specialAdCategories, setSpecialAdCategories] = useState([]);
    const [genders, setGenders] = useState([]);
    const [geoLocations, setGeoLocations] = useState(dataItem?.geo_locations ?? []);
    const [interests, setInterests] = useState(dataItem?.interests ?? []);

    useEffect(() => {
        loadCombo();
    }, []);

    const loadCombo = async () => {
        const genderRes = Object.keys(META_GENDERS).map(key => ({
            _id: META_GENDERS[key],
            description: key
        }));
        setGenders(genderRes);
        const specialAdCategoriesRes = Object.keys(META_SPECIAL_AD_CATEGORIES).map(key => ({
            _id: META_SPECIAL_AD_CATEGORIES[key],
            description: key
        }));
        setSpecialAdCategories(specialAdCategoriesRes);
    }

    const debounceRef = useRef(null);

    const loadDropdownValue = (value, name) => {
        if (!value) return;
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }
        debounceRef.current = setTimeout(async () => {
            if (name === "geo_locations") {
                const response = await API.getGeoLocations({ _id: dataItem?.channel?._id, adType: dataItem?.channel?.adType }, value);
                if (response.success) {
                    const newOptions = response.data;
                    const merged = [...dataItem.geo_locations, ...newOptions.filter(
                        (opt) => !dataItem.geo_locations.some((old) => old.key === opt.key))];
                    setGeoLocations(merged);
                } else {
                    setGeoLocations([]);
                }
            } else if (name === "interests") {
                const response = await API.getInterests({ _id: dataItem?.channel?._id, adType: dataItem?.channel?.adType }, value);
                if (response.success) {
                    const newOptions = response.data;
                    const merged = [...dataItem.interests, ...newOptions.filter(
                        (opt) => !dataItem.interests.some((old) => old.id === opt.id))];
                    setInterests(merged);
                } else {
                    setInterests([]);
                }
            }
        }, 500);
    };

    return (
        <>
            <div className='row mt-2'>
                <div className='col-4'>
                    <label htmlFor="geo_locations">{lang.geo_locations_label} *</label>
                    <GetInstedDataDropdown
                        name="geo_locations"
                        textField="name"
                        dataItemKey="key"
                        data={geoLocations}
                        value={dataItem.geo_locations} 
                        onChange={onChange}
                        onInputChange={(inputValue) => loadDropdownValue(inputValue, "geo_locations")}
                        isMulti={true}
                    />
                </div>
                <div className='col-4'>
                    <label htmlFor="interests">{lang.interests_label} *</label>
                    <GetInstedDataDropdown
                        name="interests"
                        textField="name"
                        dataItemKey="id"
                        data={interests}
                        value={dataItem.interests}
                        onChange={onChange}
                        onInputChange={(inputValue) => loadDropdownValue(inputValue, "interests")}
                        isMulti={true}
                    />
                </div>
                <div className='col-4'>
                    <label htmlFor="special_ad_categories">{lang.special_add_category_label}</label>
                    <MyMultiSelect
                        name="special_ad_categories"
                        textField="description"
                        dataItemKey="_id"
                        data={specialAdCategories}
                        value={dataItem.special_ad_categories}
                        onChange={onChange}
                        // isMulti={true}
                    />
                </div>
            </div>
            <div className='row mt-2'>
                <div className='col-4'>
                    <label htmlFor="genders">{lang.genders_label} *</label>
                    <MyMultiSelect
                        name="genders"
                        textField="description"
                        dataItemKey="_id"
                        data={genders}
                        value={dataItem.genders}
                        onChange={onChange}
                        // isMulti={true}
                    />
                </div>
                <div className='col-4'>
                    <label htmlFor="age_min">{lang.minimum_age_label} *</label>
                    <input
                        type="number"
                        name="age_min"
                        placeholder="Enter Minimum Age"
                        className='form-control form-control-sm'
                        value={dataItem.age_min}
                        min={0}
                        onChange={onChange}
                    />
                </div>
                <div className='col-4'>
                    <label htmlFor="age_max">{lang.maximum_age_label} *</label>
                    <input
                        type="number"
                        name="age_max"
                        placeholder="Enter Maximum Age"
                        className='form-control form-control-sm'
                        value={dataItem.age_max}
                        min={0}
                        onChange={onChange}
                    />
                </div>
            </div>
        </>
    )
}

export default MetaAudienceForm
